
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers",
      function () {
        return require("private-next-pages/special-offers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-offers"])
      });
    }
  